/**
 * Network downloader with progress tracking.
 *
 * Uses fetch() + ReadableStream to report download progress for large
 * GGUF model files.
 */

export async function downloadModel(
  url: string,
  onProgress: (loaded: number, total: number) => void,
): Promise<Blob> {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Download failed: ${response.status} ${response.statusText}`);
  }

  const contentLength = Number(response.headers.get("content-length") ?? -1);
  const body = response.body;

  // If no body stream (shouldn't happen), fall back to simple blob read.
  if (!body) {
    const blob = await response.blob();
    onProgress(blob.size, blob.size);
    return blob;
  }

  const reader = body.getReader();
  const chunks: BlobPart[] = [];
  let loaded = 0;

  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    chunks.push(value.buffer.slice(value.byteOffset, value.byteOffset + value.byteLength));
    loaded += value.byteLength;
    onProgress(loaded, contentLength);
  }

  return new Blob(chunks);
}
